import { render, staticRenderFns } from "./PDFMergeAndSplit.vue?vue&type=template&id=70ae795a&scoped=true"
import script from "./PDFMergeAndSplit.vue?vue&type=script&lang=js"
export * from "./PDFMergeAndSplit.vue?vue&type=script&lang=js"
import style0 from "./PDFMergeAndSplit.vue?vue&type=style&index=0&id=70ae795a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae795a",
  null
  
)

export default component.exports